export default "__VITE_ASSET__B0b2pibc__"